import React, {useContext} from "react";
import i18n from "i18next";
import {RouteComponentProps, withRouter} from "react-router";
import {DamageModelWithDirection} from "../../../../../../models/tcr";
import Table from "../../../../../../../common/components/shared/table/table";
import {storesContext} from "../../../../../../../common/stores/stores";
import TcrUtils from "../../../../../../../helpers/tcrUtils";
import {observer} from "mobx-react";
import "./damagesTable.scss";
import TransportUtils from "../../../../../../../helpers/transportUtils";
import { SideType } from "../../../../../../models/transport";

interface DamagesTableProps extends RouteComponentProps {
    sideType: SideType;
}

function DamagesTable(props: DamagesTableProps): React.ReactElement {
    const sideType = props.sideType;
    const properties = ["direction", "damageUpdateTime", "code", "equipmentType", "damageType"];
    const headers = properties.map(key => i18n.t("transportation.order.tcr.sections.trailerCondition.modifyTrailerDamages.headers." + key));
    const tcrStore = useContext(storesContext).tcrStore;
    const rows = getRows();

    return (
        <div className="damages-table">
            <Table
                headers={headers}
                rows={rows}
                properties={properties}
                renderCell={renderCell}
                actions={renderActions}
                testId="damages-table"
                currentPage={0}
                numberOfElements={0}
                pageable={false}
            />
        </div>
    );

    function renderActions(): React.ReactElement {
        // TODO: Add "remove" button
        return <></>;
    }

    function renderCell(row: any, property: string): JSX.Element {
        const value = row[property];
        switch (property) {
            case "damageUpdateTime":
                return TcrUtils.renderDamageUpdateTime(value);
            case "code":
                return TcrUtils.renderTcrCode(row);
            case "damageType":
                return TcrUtils.renderDamageType(value);
            case "direction":
                return TransportUtils.renderDirection(value);
            case "equipmentType":
                return TcrUtils.renderEquipment(row);
            default:
                return value;
        }
    }

    function getRows(): DamageModelWithDirection[] {
        const damagesForSide = tcrStore.damages.filter(x => x.sideType === sideType);
        const rows: DamageModelWithDirection[] = [];

        damagesForSide.map((damage: DamageModelWithDirection) => {
            rows.push({
                direction: damage.direction,
                damageUpdateTime: damage.damageUpdateTime,
                equipmentType: damage.equipmentType,
                damageType: damage.damageType,
                damageLocation: damage.damageLocation,
                sideType
            });
        });

        return rows;
    }
}

export default withRouter(observer(DamagesTable));
